import React from 'react';

function CompareImages({ imageUrl, imageUrl2, onJudge }) {
  return (
    <div className="w-full items-center space-x-4">
      {/* 見出しを見出しらしくスタイル */}
      <header className="w-full flex justify-center mb-6">
        <h1 className="text-2xl md:text-3xl font-extrabold tracking-tight text-gray-800 dark:text-gray-100">
          どの画像の誤りを判定する？
        </h1>
      </header>
      <div className="flex justify-center items-center gap-4">
        {imageUrl && (
          <div className="flex-1 text-center">
            <h2 className="text-lg font-semibold mb-2">画像1:</h2>
            <div className="flex justify-center">
              <img
                src={imageUrl}
                alt="Uploaded1"
                className="mt-4 max-w-full h-auto rounded border"
              />
            </div>
            <div className="mt-2">
              <button
                onClick={() => onJudge(1)}
                className="btn btn--primary"
              >
                画像1を選択
              </button>
            </div>
          </div>
        )}
        {imageUrl2 && (
          <div className="flex-1 text-center">
            <h2 className="text-lg font-semibold mb-2">画像2:</h2>
            <div className="flex justify-center">
              <img
                src={imageUrl2}
                alt="Uploaded2"
                className="mt-4 max-w-full h-auto rounded border"
              />
            </div>
            <div className="mt-2">
              <button
                onClick={() => onJudge(2)}
                className="btn btn--primary"
              >
                画像2を選択
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CompareImages;